import { SimpleGrid } from "@chakra-ui/react";

const GridRow = (props) => {
    const {columns = 12, spacing = 4, columnGap = 8, rowGap = 2, mb = 3} = props;
  return (
    <SimpleGrid columns={columns} spacing={spacing} columnGap={columnGap} rowGap={rowGap} mb={mb}>{props.children}</SimpleGrid>
  );
};

export default GridRow;
